 
    <div class="content-inner">
      <div class="inner-border">
        <form [formGroup]="formGroup">
          <div class="form-group">
            <span class="label" for="name">Name</span>
            <input type="text" #clientName name="name" (change)="trimValue('name')" id="name" formControlName="name" maxlength="150">
            <span *ngIf="formGroup.get('name').errors &&
            formGroup.get('name').hasError('required') " class="validation-error">Name is required.</span>
            </div>
          <ng-template [ngIf]="!isNew || (isNew && !isHuronEmployee())">
            <div class="form-group">
              <span class="label">Corporation</span>
              <input type="text" name="corporation" formControlName="corporation" id="corporation" readonly [(ngModel)]="activeClient.corporationName">
            </div>
          </ng-template>
          <ng-template [ngIf]="isNew && isHuronEmployee()">
            <div class="form-group">
              <span class="label" name="corporationIdLabel" for="corporationId">
                Corporation 
              </span>
              <select required
                      name="corporationId" id="corporationId" formControlName="corporationId">
                <option value="" hidden></option>
                <option *ngFor="let corporation of corporations" [value]="corporation.id">
                  {{ corporation.name }}
                </option>
              </select>
              <span *ngIf="formGroup.get('corporationId').errors &&
            formGroup.get('corporationId').hasError('required') " class="validation-error">Corporation is required.</span>
            </div>
          </ng-template>         
            <div class="form-group">
              <span class="label" name="majorityClientTimeZoneLabel" for="timeZoneId">
                Majority Client Time Zone
              </span>
              <select required
                      name="timeZoneId" id="timeZoneId" formControlName="timeZoneId" class="w-100">
                <option value="" hidden>Select</option>
                <option *ngFor="let timeZone of timeZones" [value]="timeZone.id">
                  {{ timeZone.description }}
                </option>
              </select>
              <span *ngIf="formGroup.get('timeZoneId').errors &&
            formGroup.get('timeZoneId').hasError('required') " class="validation-error">Majority Client Time Zone is required.</span>
            </div>          
          <div class="inner-sub-border mb-2">
            <span class="subinner-subtit">Status</span>
            <div class="row">
              <div class="col-3">
                <div class="form-group">
                  <span class="label">Status</span>
                  <select [value]="activeClient.isActive"
                          (change)="changeSelectedStatus($event, activeClient)" name="status" id="status" formControlName="status" [ngClass]="{'select-read-only':!isHuronEmployee()}">
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </select>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <span class="label">Sync Status</span>
                  <span class="material-symbols-outlined"
                        [ngClass]="{'success': activeClient.upsertStatus, 'error': !activeClient.upsertStatus }">
                        {{ activeClient.upsertStatus ? 'check_circle' : 'error' }}
                  </span>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <span class="label">Created Date</span>
                  <span class="label">{{ activeClient.createdDate | date :'MM/dd/yyyy h:mm:ss a' }}</span>
                </div>
              </div>
            </div>
          </div>
          <ng-template #accountNumber_editable [ngIf]="isHuronEmployee() && isNew">
            <div class="form-group">
              <span class="label" for="accountNumber">
                Account Number &nbsp;
                <span class="icon-info" [matTooltipPosition]="'right'"
                      matTooltip="Unique Identifier matching the client number from Workday"></span>
              </span>
              <input type="text" name="accountNumber" id="accountNumber" formControlName="accountNumber" maxlength="50" (change)="trimValue('accountNumber')">
              <span *ngIf="formGroup.get('accountNumber').errors &&
            formGroup.get('accountNumber').hasError('required') " class="validation-error">Account Number is required.</span>
            </div>
          </ng-template>
          <ng-template #accountNumber_disabled [ngIf]="!isNew">
            <div class="form-group">
              <span class="label" for="accountNumber">Account Number</span>
              <input type="text" readonly name="accountNumber" id="accountNumber" formControlName="accountNumber">
            </div>
          </ng-template>
          <div class="form-group">
            <span class="label" for="website">Website</span>
            <input type="text" name="website" id="website"
                   formControlName="website" maxlength="100">
            <span class="validation-error">{{ getError('website',100) }}</span>
          </div>    
          <div class="inner-sub-border mt-2">
            <span class="subinner-subtit">Also Known As</span>
            <div class="form-group">
              <div class="row ml-0">
                <input class="mr-2" style="width:400px" type="text" name="new-aka" id="new-aka"
                       value="" maxlength="150" formControlName="newaka">
                <div class="button-grp">
                  <button id="add-new-aka" class="btn-light mx-2"
                          (click)="addClientAKA();" [disabled]="!isHuronEmployee()">
                    Add
                  </button>
                  <button id="clear-new-aka" class="btn-default mx-2"
                          (click)="clearClientAKA();" [disabled]="!isHuronEmployee()">
                    Clear
                  </button>
                </div>
              </div>
                
                <div *ngIf="newAkaError" class="validation-error">Please enter valid data.</div>
              </div>
              <ng-template [ngIf]="activeClient.clientAkaModels && activeClient.clientAkaModels.length">
                <br>
                <ng-template ngFor let-alsoKnownAs [ngForOf]="activeClient.clientAkaModels"
                             let-i="index">
                  <ng-template [ngIf]="!alsoKnownAs.isEditing">
                    <div class="row ml-0">
                      <div class="value-wrapper">
                        <div class="value-1 pl-2">
                          {{ alsoKnownAs.aka }}
                        </div>
                        <ng-template [ngIf]="isaHuronEmployee">
                          <div class="button-grp">
                            <a id="edit-aka-{{i}}" (click)="editClientAKA(i)">
                              <span class="material-symbols-outlined">edit</span>
                            </a>
                            <a id="remove-aka-{{i}}" (click)="removeClientAKA(i)">
                              <span class="material-symbols-outlined">delete</span>
                            </a>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template [ngIf]="alsoKnownAs.isEditing">
                    <div class="form-group">
                      <div class="row ml-0">
                        <input class="mr-2" style="width:400px" type="text" name="edit-aka{{i}}"
                               id="edit-aka{{i}}" #editAKA value="{{alsoKnownAs.aka}}" formControlName="editAka" maxlength="150">
                        <div class="button-grp">
                          <button id="save-aka-{{i}}" class="btn-light mx-2"
                                  (click)="saveClientAKAEdit(editAKA, i)">
                            Apply
                          </button>
                          <button id="cancel-aka-{{i}}" class="btn-default mx-2"
                                  (click)="cancelClientAKAEdit(i)">
                            Cancel
                          </button>
                        </div>
                        <div *ngIf="showEditError(editAKA)" class="validation-error">
                          Please enter valid data.
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ng-template>
              </ng-template>
            </div>

          <div class="inner-sub-border mt-2">
            <span class="subinner-subtit">Address</span>
            <div class="row">
              <div class="col-2">
                <div class="form-group">
                  <span class="label" for="address1">Address 1</span>
                  <input type="text" name="address1" id="address1"
                         formControlName="address1" maxlength="150">
                  <span *ngIf="formGroup.get('address1').errors &&
            formGroup.get('address1').hasError('maxlength') && isSubmitted" class="validation-error">Address1 cannot exceed more than 100 characters</span>
                </div>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <span class="label" for="address2">Address 2</span>
                  <input type="text" name="address2" id="address2"
                         formControlName="address2" maxlength="150">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <div class="form-group">
                  <span class="label" for="city">City</span>
                  <input type="text" name="city" id="city"
                         formControlName="city" maxlength="100">
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <span class="label" for="state">State</span>
                  <input type="text" name="state" id="state"
                         formControlName="state" maxlength="3">
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <span class="label" for="zip">Zip</span>
                  <input type="text" name="zip" id="zip"
                         formControlName="zip" maxlength="10">
                </div>
              </div>
            </div>
          </div>

          <ng-template [ngIf]="showContracts" id="huroncontractsfieldset">
            <div class="inner-sub-border mt-2">
              <span class="subinner-subtit">Huron Contracts</span>
              <div class="form-group d-flex pb-0">
                <div class="col-d1">
                  <span class="label" for="contractName">Name</span>
                  <div class="row ml-0">
                    <input class="huron-contracts mr-2" type="text"
                           name="contractName" id="contractName" formControlName="contractName" maxlength="100">
                  </div>
                </div>
                <div class="col-d1" [class.error]="newHuronContractError && isSubmitted">
                  <span class="label" for="contractNumber">
                    Number 
                  </span>
                  <div class="row ml-0">
                    <input class="huron-contracts mr-2" type="text"
                           name="contractNumber" id="contractNumber" formControlName="contractNumber" maxlength="50" (change)="trimValue('contractNumber')">                           
                  </div>
                  <span *ngIf="formGroup.get('contractNumber').errors &&
                           formGroup.get('contractNumber').hasError('required')" class="validation-error">Number is required.</span>
                </div>
                <div class="col-d1">
                  <span class="label" for="contractNotes">Notes</span>
                  <div class="row ml-0">
                    <textarea class="mr-2" name="contractNotes"
                              id="contractNotes" col="2" row="1" formControlName="contractNotes" maxlength="1000"></textarea>
                  </div>
                </div>
                <div class="button-grp" style="align-items:center; flex-direction: column;">
                  <button id="add-contract" class="btn-light mx-2 mb-1"
                          (click)="addHuronContract()">
                    Add
                  </button>
                  <button id="clear-contract" class="btn-default mx-2"
                          (click)="clearHuronContract()" [disabled]="!isHuronEmployee()">
                    Clear
                  </button>
                </div>
              </div>
              <div class="form-group mt-2">
                <div *ngIf="activeClient.clientHuronContractModels && activeClient.clientHuronContractModels.length > 0">
                  <div class="cl-parent">
                    <div class="d-flex">
                      <div class="cl-col cl-head" style="padding-left: 5px;">Name</div>
                      <div class="cl-col cl-head pl-0">Number</div>
                      <div class="cl-col cl-head pl-0">Notes</div>
                    </div>

                    <ng-template ngFor let-huronContract
                                 [ngForOf]="activeClient.clientHuronContractModels" let-i="index">
                      <ng-template [ngIf]="!huronContract.isEditing">
                        <div class="cl-child">
                          <div class="cl-col">{{ huronContract.name }}</div>
                          <div class="cl-col">{{ huronContract.number }}</div>
                          <div class="cl-col">{{ huronContract.notes }}</div>
                          <div class="cl-col">
                            <ng-template [ngIf]="isaHuronEmployee">
                              <div class="button-grp">
                                <a id="edit-contract-{{i}}" (click)="editHuronContract(i)">
                                  <div class="material-symbols-outlined" style="width:20px">edit</div>
                                </a>&nbsp;
                                <a id="remove-contract-{{i}}"
                                   (click)="removeHuronContract(i)">
                                  <div class="material-symbols-outlined" style="width:20px">delete</div>
                                </a>
                              </div>
                            </ng-template>
                          </div>
                        </div>
                      </ng-template>
                      <ng-template [ngIf]="huronContract.isEditing">
                        <div class="form-group d-flex pb-0 mt-1 mb-1">
                          <div class="col-d1" style="width: 29%;">
                            <div class="row ml-0">
                              <input #editHuronContractName class="huron-contracts mr-2" type="text"
                                     value="{{huronContract.name}}" name="contractName{{i}}"
                                     id="contractName{{i}}" formControlName="editContractName" maxlength="150">
                              <div *ngIf="showEditError(editHuronContractName)"
                                   class="validation-error">Please enter valid contract name.</div>
                            </div>
                          </div>
                          <div class="col-d1" style="width: 29%;">
                            <div class="row ml-0">
                              <input #editHuronContractNumber class="huron-contracts mr-2" type="text"
                                     value="{{huronContract.number}}"
                                     name="contractNumber{{i}}" id="contractNumber{{i}}" formControlName="editContractNumber" maxlength="50">
                            </div>
                          </div>
                          <div class="col-d1" style="width: 29%;">
                            <div class="row ml-0">
                              <textarea #editHuronContractNotes class="mr-2"
                                        name="contractNotes{{i}}" id="contractNotes{{i}}"
                                        col="2" row="1" value="{{huronContract.notes}}" formControlName="editContractNotes" maxlength="1000"></textarea>
                            </div>
                          </div>
                          <div class="col-1">
                            <div class="button-grp" style="align-items: center; flex-direction: column;">
                              <button id="save-contract-{{i}}" class="btn-light mx-2 mb-1"
                                      (click)="saveEditHuronContract(editHuronContractName, editHuronContractNumber, editHuronContractNotes, i)">
                                Apply
                              </button>
                              <button id="cancel-contract-{{i}}" class="btn-default mx-2"
                                      (click)="cancelEditHuronContract(i)">
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                        <br>
                      </ng-template>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div *ngIf="newHuronContractError && isSubmitted" class="validation-error">
                * One or more Huron Contracts are required
              </div>
            </div>
          </ng-template>

          <ng-template [ngIf]="applications && applications.length > 0">
            <div class="inner-sub-border mt-2">
              <span class="subinner-subtit">Applications</span>
              <hr>
              <table class="huronFormTable" *ngIf="isHuronEmployee()">
                <thead>
                  <tr>
                    <th>Pur.</th>
                    <th>Act.</th>
                    <th>Application</th>
                    <th>Access Token</th>
                    <th>Identity Token</th>
                    <th>Marketplace Product Code</th>
                    <th>Marketplace Customer Id</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-template ngFor let-application [ngForOf]="applications" let-i="index">
                    <tr>
                      <td>
                        <input type="checkbox"
                               [disabled]="isDependentApplicationInactive(application)"
                               [checked]="clientHasPurchasedApplication(application)"
                               (click)="onClientApplicationPurchasedChecked($event, application)"
                               name="pur{{i}}" id="pur{{i}}"
                               attr.aria-label="Purchase {{ application.name }}" >
                        <input type="hidden" id="hdnpur{{i}}" value="{{application.id}}" />
                      </td>
                      <td>
                        <input type="checkbox"
                               [disabled]="!clientHasPurchasedApplication(application)"
                               [checked]="clientHasActiveApplication(application)"
                               (click)="onClientApplicationChecked($event, application)"
                               name="app{{i}}" id="app{{i}}"
                               attr.aria-label="Activate {{ application.name }}" >
                        <input type="hidden" id="hdnapp{{i}}" value="{{application.id}}" />
                      </td>
                      <td>
                        <label id="lblApp{{i}}">
                          {{ application.name }}{{
                                                    addAsteriskForPCMandVM(application.name)
                          }}
                        </label>
                      </td>
                      <td class="input">
                        <div class="form-group table-cell"
                             [class.error]="showAccessTokenLifetimeError(application)">
                          <label for="accessTokenLifetime{{getClientApplicationIndex(application)}}"
                                 class="offscreen">
                            {{application.name}} Access Token
                          </label>
                          <input *ngIf="clientHasActiveApplication(application)" type="number" #accessToken
                                 name="accessTokenLifetime{{getClientApplicationIndex(application)}}"
                                 id="accessTokenLifetime{{getClientApplicationIndex(application)}}"
                                 value={{activeClient.clientApplicationModels[getClientApplicationIndex(application)].accessTokenLifetime}}
                                 (change)="markasDirty();SetAccessTokenValue(accessToken,application)" 
                                 [ngClass]="{'ng-invalid': isApplicationAccessTokenLifetimeInvalid(application)}">
                          <div *ngIf="isApplicationAccessTokenLifetimeInvalid(application)"
                               class="validation-error">Required</div>
                        </div>
                      </td>
                      <td class="input">
                        <div class="form-group table-cell"
                             [class.error]="showIdTokenLifetimeError(application)">
                          <label for="identityTokenLifetime{{getClientApplicationIndex(application)}}"
                                 class="offscreen">
                            {{application.name}} Identity Token
                          </label>
                          <input *ngIf="clientHasActiveApplication(application)" type="number" #identityToken
                                 name="identityTokenLifetime{{getClientApplicationIndex(application)}}"
                                 id="identityTokenLifetime{{getClientApplicationIndex(application)}}"
                                 value={{activeClient.clientApplicationModels[getClientApplicationIndex(application)].identityTokenLifetime}}
                                 (change)="markasDirty();SetIdentityTokenValue(identityToken, application)" 
                                 [ngClass]="{'ng-invalid': isApplicationIdentityTokenLifetimeInvalid(application)}">
                          <div *ngIf="isApplicationIdentityTokenLifetimeInvalid(application)"
                               class="validation-error">Required</div>
                        </div>
                      </td>
                      <td class="input">
                        <div class="form-group table-cell">
                          <label for="awsMarketplaceProductCode{{getClientApplicationIndex(application)}}"
                                 class="offscreen">
                            {{application.name}} Product Code
                          </label>
                          <input *ngIf="clientHasActiveApplication(application)" type="text" #marketPlaceProductCode
                                 name="awsMarketplaceProductCode{{getClientApplicationIndex(application)}}"
                                 id="awsMarketplaceProductCode{{getClientApplicationIndex(application)}}"
                                 value={{activeClient.clientApplicationModels[getClientApplicationIndex(application)].awsMarketplaceProductCode}}
                                 (change)="markasDirty();SetMarketplaceProductCode(marketPlaceProductCode,application)">
                        </div>
                      </td>
                      <td class="input">
                        <div class="form-group table-cell">
                          <label for="awsMarketplaceCustomerId{{getClientApplicationIndex(application)}}"
                                 class="offscreen">
                            {{application.name}} Customer Id
                          </label>
                          <input *ngIf="clientHasActiveApplication(application)" type="text" #marketPlaceCustomerId
                                 name="awsMarketplaceCustomerId{{getClientApplicationIndex(application)}}"
                                 id="awsMarketplaceCustomerId{{getClientApplicationIndex(application)}}"
                                 value={{activeClient.clientApplicationModels[getClientApplicationIndex(application)].awsMarketplaceCustomerId}}
                                 (change)="markasDirty();SetMarketplaceCustomerId(marketPlaceCustomerId,application)">
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>
              <p class="note">
                * Clients cannot purchase both Leadership Evaluation Manager and Validation
                Matrix. They may only purchase one at a time.
              </p>
              <table class="huronFormTable" *ngIf="!isHuronEmployee()">
                <thead>
                  <tr>
                    <th>Application</th>
                    <th>Access Token</th>
                    <th>Identity Token</th>
                    <th>Product Code</th>
                    <th>Customer Id</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let application of activeClientApplications; let i = index;">
                    <td>
                      {{ application.name }}
                    </td>
                    <td>
                      {{
                                            activeClient.clientApplicationModels[getClientApplicationIndex(application)].accessTokenLifetime
                      }}
                    </td>
                    <td>
                      {{
                                            activeClient.clientApplicationModels[getClientApplicationIndex(application)].identityTokenLifetime
                      }}
                    </td>
                    <td>
                      {{
                                            activeClient.clientApplicationModels[getClientApplicationIndex(application)].awsMarketplaceProductCode
                      }}
                    </td>
                    <td>
                      {{
                                            activeClient.clientApplicationModels[getClientApplicationIndex(application)].awsMarketplaceCustomerId
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-template>

          <div class="inner-sub-border mt-2">
            <span class="subinner-subtit">Contacts</span>
            <span class="info-warning">Name and Email information is mandatory to add contact/s</span>
            <div class="form-group d-flex pb-0 mt-1">
              <div class="col-1">
                <span class="label" for="contactName">Name</span>
                <div class="row ml-0">
                  <input class="mr-2" #addContactName type="text" name="contactName"
                         id="contactName" style="width:165px; height: 32px;" formControlName="contactName" maxlength="100">
                </div>
                <span *ngIf="formGroup.get('contactName').errors && formGroup.get('contactName').hasError('required') " class="validation-error">
                  Please enter a contact name.
                </span>
              </div>
              <div class="col-1">
                <span class="label" for="phone">Phone</span>
                <div class="row ml-0">
                  <input class="mr-2" type="text" name="phone" #addContactPhone
                         id="phone" style="width:165px; height: 32px;" formControlName="phone" maxlength="50" [ngClass]="{'ng-invalid': !validateContactPhoneNumber(addContactPhone)}">
                </div>
                <div *ngIf="!validateContactPhoneNumber(addContactPhone)" class="validation-error">Please enter a valid phone number.</div>
              </div>
              <div class="col-1">
                <span class="label" for="roleOrTitle">Role or Title</span>
                <div class="row ml-0">
                  <input class="mr-2" type="text" #addContactRole
                         name="roleOrTitle" id="roleOrTitle"
                         style="width:165px; height: 32px;" formControlName="roleOrTitle" maxlength="50">
                </div>
              </div>
              <div class="col-1">
                <span class="label" for="contactNotes">Notes</span>
                <div class="row ml-0">
                  <textarea class="mr-2" name="contactNotes"
                            id="contactNotes" formControlName="contactNotes" #addContactNotes maxlength="1000">
                                    </textarea>
                </div>
              </div>
            </div>

            <div class="form-group d-flex pb-1">
              <div class="col-1">
                <span class="label">Email(s)</span>
                <div class="row ml-0 fwrap">
                  <ul class="custom-email pl-0 d-flex fwrap" #addEmailList id="addEmailList">
                    <li class="custom-email-item ml-0 mr-1 mb-1 px-0 py-0 h-35 mt-15 no-border" *ngFor="let email of newContact.clientContactEmailModels; let i=index">
                      <input [ngClass]="{'ng-invalid': (i > 0)}" class="contactEmail{{i}}" type="text" name="contactEmail{{i}}" class="w-165"
                             id="contactEmail{{i}}"  maxlength="100" (change)="onEmailChangeEvent($event,i)" [disabled]="!isHuronEmployee()">
                    </li>
                  </ul>
                  <button id="add-email"
                  *ngIf="newContact.clientContactEmailModels && (newContact.clientContactEmailModels[0].email || newContact.clientContactEmailModels[0].email == '')"
                          (click)="addClientContactEmail()" class="btn-light btn-h-35 mx-0">
                    Add
                  </button>
                </div>
                <div *ngIf="newContactErrorMessageShow" class="validation-error">Please enter valid email(s).</div>
              </div>
            </div>
            <div class="form-group d-flex">
              <div class="col-2 pl-0">
                <span class="label">Applications</span>
                <div class="chk-border ml-0">
                  <div class="checkbx-group"
                       *ngFor="let clientApplication of activeClient.clientApplicationModels | activeFilter">

                    <input #newContactApp (change)="clientContactAppChecked(newContactApp)"
                           type="checkbox" value="{{clientApplication.applicationId}}"
                           [checked]="newContactHasApp(clientApplication.applicationId)" formControlName="application{{clientApplication.applicationId}}" >
                    <label for="delete">{{ clientApplication.applicationName }} </label><br>
                  </div>
                </div>
              </div>
              <div class="button-grp" style="align-items: center">
                <button class="btn-light mx-2" id="add-contact"
                        (click)="addClientContact(addContactName,addContactPhone, addContactRole, addContactNotes, addEmailList)" 
                        [disabled]="!isHuronEmployee() || disableAddContact(addContactName,addContactPhone, addEmailList, true)">  
                  Add Contact
                </button>
                <button class="btn-default mx-2" id="clear-contact"
                        (click)="clearClientContact()" [disabled]="!isHuronEmployee()">
                  Clear
                </button>
              </div>
            </div>
            <br>
            <table class="huronFormTable"
                   *ngIf="activeClient.clientContactModels && activeClient.clientContactModels.length > 0">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Role or Title</th>
                  <th>Email(s)</th>
                  <th>Notes</th>
                  <th>Applications</th>
                  <th><span class="offscreen">Edit Contact</span></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let contact of activeClient.clientContactModels; let i=index">
                  <ng-template [ngIf]="!contact.isEditing">
                    <td class="text-top">{{ contact.name }}</td>
                    <td class="text-top">{{ contact.phone }}</td>
                    <td class="text-top">{{ contact.roleOrTitle }}</td>
                    <td class="text-top">
                      <ng-template [ngIf]="contact.clientContactEmailModels" ngFor
                                   let-contactEmail [ngForOf]="contact.clientContactEmailModels">
                        {{contactEmail.email}}
                        <br>
                      </ng-template>
                    </td>
                    <td class="text-top">{{contact.notes}}</td>
                    <td class="text-top">
                      <ng-template [ngIf]="contact.clientContactApplicationModels" ngFor
                                   let-contactApp
                                   [ngForOf]="activeClient.clientApplicationModels | contactHasAppFilter : contact.clientContactApplicationModels">
                        {{ contactApp.applicationName }}
                        <br>
                      </ng-template>
                    </td>
                    <ng-template [ngIf]="isaHuronEmployee">
                      <td class="button-grp text-top">
                        <a id="edit-clientContact-{{i}}" (click)="editClientContact(i)">
                          <div class="material-symbols-outlined" style="width:20px">edit</div>
                        </a>
                        <a id="remove-clientContact-{{i}}" (click)="removeClientContact(i)">
                          <div class="material-symbols-outlined" style="width:20px">delete</div>
                        </a>
                      </td>
                    </ng-template>
                    </ng-template>
                    <ng-template [ngIf]="contact.isEditing">
                      <td colspan="7">
                        <div class="form-group d-flex pb-0">
                          <div class="col-1">
                            <span class="label" for="contactName{{ i }}">Name</span>
                            <div class="row ml-0">
                              <input #editContactName class="mr-2" type="text"
                                     name="contactName{{ i }}" id="contactName{{ i }}"
                                     value="Hello{{ contact.name }}" formControlName="editContactName" maxlength="100">
                            </div>
                            <div *ngIf="!editedContactValidName" class="validation-error">
                              Please enter valid contact name.
                            </div>
                          </div>
                          <div class="col-1">
                            <span class="label" for="phone{{ i }}">Phone</span>
                            <div class="row ml-0">
                              <input #editContactPhone class="mr-2" type="text"
                                     name="phone{{ i }}" id="phone{{ i }}"
                                     value="{{ contact.phone }}" formControlName="editPhone" maxlength="50"
                                     [ngClass]="{'ng-invalid': !editedContactValidPhone}">
                            </div>
                            <div *ngIf="!editedContactValidPhone" class="validation-error">
                              Please enter valid phone number.
                            </div>
                          </div>
                          <div class="col-1">
                            <span class="label" for="roleOrTitle{{ i }}">Role or Title</span>
                            <div class="row ml-0">
                              <input #editContactRole class="mr-2" type="text"
                                     name="roleOrTitle{{ i }}" id="roleOrTitle{{ i }}"
                                     value="{{ contact.roleOrTitle }}" formControlName="editRoleOrTitle" maxlength="50">
                            </div>
                          </div>
                          <div class="col-1">
                            <span class="label" for="contactNotes{{ i }}">Notes</span>
                            <div class="row ml-0">
                              <textarea #editContactNotes class="mr-2"
                                        name="contactNotes{{ i }}" id="contactNotes{{ i }}" formControlName="editContactNotes" maxlength="1000"></textarea>
                            </div>
                          </div>
                        </div>
                        <div class="form-group d-flex pb-0">
                          <div class="col-1">
                            <span class="label">Email(s)</span>
                            <div class="row ml-0 fwrap">
                              <ul #editEmailList class="custom-email  pl-0 d-flex fwrap"  id="editEmailList">
                                <li class="custom-email-item ml-0 mr-1 mb-1 px-0 py-0 h-35 mt-15 no-border" *ngFor="let email of contact.clientContactEmailModels; let j=index">
                                  <input [ngClass]="{'ng-invalid': email.email == undefined }"  type="text" name="contactEmail{{ i }}-{{ j }}" class="editEmail{{j}}" class="w-165"
                                         id="contactEmail{{ i }}-{{ j }}" value="{{ email.email }}" (change)="markasDirty();editContactEmailValidation(editEmailList,i);" maxlength="100">
                                </li>
                              </ul>
                              <button class="btn-light btn-h-35 mx-0" id="contact{{ i }}-add-email"
                                      (click)="addEditClientContactEmail(contact)">
                                Add
                              </button>
                            </div>
                            <div *ngIf="editContactErrorMessageShow" class="validation-error">Please enter valid email(s).</div>
                          </div>
                        </div>
                        <div class="form-group d-flex">
                          <div class="col-1">
                            <span class="label">Applications</span>
                            <div class="chk-border ml-0">
                              <ul #editAppList style="list-style-type:none;">
                                <li *ngFor="let clientApplication of activeClient.clientApplicationModels | activeFilter">
                                  <label>
                                    <input type="checkbox" value="{{clientApplication.applicationId}}"
                                           [checked]="contactHasApplication(contact, clientApplication.applicationId)" (click)="markasDirty()">
                                    {{ clientApplication.applicationName }}
                                  </label>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div class="button-grp" style="align-items: center">
                            <button class="btn-light mx-2" id="contact{{ i }}-save"
                                    (click)="saveEditContact(editContactName, editContactPhone, editContactRole, editContactNotes, editEmailList, editAppList, i)"
                                    [disabled]="disableAddContact(editContactName,editContactPhone, editEmailList, false)">
                              Apply
                            </button>
                            <button class="btn-default mx-2" id="contact{{ i }}-cancel" (click)="cancelEditContact(i)">
                              Cancel
                            </button>
                          </div>
                        </div>
                      </td>
                    </ng-template>
</tr>
              </tbody>
            </table>
          </div>

          <!-- this selector is for studer organization information coming from the studer organization module/component -->
          <show-studer-organization #orgForm *ngIf="isStuderApplicationSelected()"
                                    [(currentClient)]="activeClient" (isEdited)="onEdited($event)"></show-studer-organization>
          <div class="form-group mt-2">
            <span class="label">Upload Client Logo</span>
            <div class="button-grp">
              <button class="btn-light" (click)="fileform.reset(); file.click()" [disabled]="!isaHuronEmployee">
                Choose File
                <form #fileform>
                  <input style="display: none;" class="button" id="fileUpload" name="fileUpload"
                         accept=".png, .jpg, .jpeg, .gif" #file type="file" multiple
                         (change)="saveFile(file.files)" />
                </form>
              </button>
            </div>
            <div class="form-group" *ngIf="isLogoAttachmentSuccessful">
              Client logo '{{logoToUpload.name}}' attached successfully. You must Save for this to take effect.
            </div>
            <div class="form-group"
                 *ngIf="!isLogoAttachmentSuccessful && activeClient.fullLogoPath?.length > 0">
              <div>
                Existing Logo:
                <img id="clientLogo" [src]="activeClient.fullLogoPath" alt="{{activeClient.name}} logo">
              </div>
              <label for="deleteClientLogo">
                <input type="checkbox" name="deleteClientLogo" id="deleteClientLogo"
                       [checked]="activeClient.removeExistingLogo" formControlName="deleteClientLogo" (click)="markasDirty()"> Delete Existing Logo?
              </label>
            </div>
            <div *ngIf="imageSizeError" class="validation-error">Images must be under 2MB.</div>
          </div>
        </form>
      </div>
    </div>   
 

